//Styles
import './styles/snack.css'

const Snack = () => {
    return (
        <div id="contSnack" style={{
            zIndex: 1001
        }}>
            
        </div>
    )
}

export default Snack